import { render } from "./AdminReviewSentRequestQuestion.vue?vue&type=template&id=32c70c4c&scoped=true&ts=true"
import script from "./AdminReviewSentRequestQuestion.vue?vue&type=script&lang=ts"
export * from "./AdminReviewSentRequestQuestion.vue?vue&type=script&lang=ts"

import "./AdminReviewSentRequestQuestion.vue?vue&type=style&index=0&id=32c70c4c&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c70c4c"]])

export default __exports__